module.exports = __webpack_public_path__ + "static/media/vuejs.21149f3e.svg";